import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const useStyles = makeStyles(() => ({
  root: {},
}));

const Default = () => {
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
    >
      <Text
        variant={'h5'}
        color={'primary'}
        text={'Not sure how to render these details.'}
      />
    </Box>
  );
};

export default Default;
